"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tabs_1 = require("./tabs");
var rails_view_store_1 = require("../rails_view_store");
var RailsView = /** @class */ (function (_super) {
    tslib_1.__extends(RailsView, _super);
    function RailsView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = rails_view_store_1.RailsViewStore.getState();
        _this.onSetHTML = _this.onSetHTML.bind(_this);
        return _this;
    }
    RailsView.prototype.componentDidMount = function () {
        rails_view_store_1.RailsViewStore.listen(this.onSetHTML);
    };
    RailsView.prototype.componentWillUnmount = function () {
        rails_view_store_1.RailsViewStore.unlisten(this.onSetHTML);
    };
    RailsView.prototype.componentDidUpdate = function () {
        var w = window;
        if (w.Reverb.ReactUJS) {
            w.Reverb.ReactUJS.init(w, this.refs.content);
        }
    };
    RailsView.prototype.onSetHTML = function () {
        this.setState(rails_view_store_1.RailsViewStore.getState());
    };
    RailsView.prototype.render = function () {
        return (React.createElement("div", { className: "feed-container" },
            React.createElement(tabs_1.default, null),
            React.createElement("div", { className: "feed-container__content", ref: "content" },
                React.createElement("div", { className: "mt-1" }),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.html } }))));
    };
    return RailsView;
}(React.Component));
exports.default = RailsView;
//# sourceMappingURL=rails_view.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/rails_view.js
// module id = kJCa
// module chunks = 20 21